import { useEffect, useState } from "react";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import Logo from "../assets/logo.png";
import { checkAuthOnce, loginUser } from "../utils/auth";
import { showToast } from "../utils/toastOptions";
import "./LoginPage.css";

export default function LoginPage() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      const authStatus = await checkAuthOnce();
      setIsAuthenticated(authStatus);
    };
    checkAuth();
  }, []);

  useEffect(() => {
    const error = new URLSearchParams(location.search).get("error");
    if (error) {
      showToast("error", error);
      // Clear the error parameter from URL
      searchParams.delete("error");
      setSearchParams(searchParams, { replace: true });
    }
  }, [searchParams, setSearchParams, location.search]);

  if (isAuthenticated) return <Navigate to="/home" replace />;

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <img src={Logo} alt="Company logo" className="logo" />
        <p className="mission">
          We leverage <strong>AI</strong> to automate and enhance construction software workflows,
          freeing teams from manual tasks like data entry and migration so they can focus on what
          truly matters.
        </p>
        <button className="login-button" onClick={loginUser}>
          Sign In With Procore
        </button>
      </div>
    </div>
  );
}
